import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Country } from "../_models/country";

@Injectable({
  providedIn: "root",
})
export class CountryService {
  constructor(private http: HttpClient, public auth: AuthService) {}

  public getCountries() {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.countries}/`;
    return this.http.get<Country[]>(requestUrl, options);
  }

  public getCountriesOld() {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Basic NjQwOTY6dW5vcHJlbWllcjEyMw==`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/countries`;
    return this.http.get<Country[]>(requestUrl, options).pipe(
      map((result: any) => {
        return result._embedded.countryList;
      })
    );
  }

  public getCountry(countryId: number) {
    const token = localStorage.getItem("prime-token");
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.countries}/${countryId}`;
    return this.http.get<Country>(requestUrl, options);
  }

  public addCountry(country: Country): Observable<Country> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.countries}/`;
    console.log(requestUrl);
    return this.http.post<Country>(requestUrl, country, options);
  }

  public updateCountry(country: Country): Observable<Country> {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.countries}/${country.id}`;
    console.log(requestUrl);
    return this.http.put<Country>(requestUrl, country, options);
  }

  public deleteCountry(countryId: number) {
    const header = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.auth.token,
    });
    const options = { headers: header };
    const requestUrl = `${environment.regionalApi}/${environment.apiEndpoints.countries}/${countryId}`;
    console.log(requestUrl);
    return this.http.delete(requestUrl, options);
  }
}
